import React from "react";
import { motion } from "framer-motion";
import { FiRepeat, FiAlertCircle } from "react-icons/fi";
import TextPost from "./TextPost";
import PhotoPost from "./PhotoPost";
import ResearchPost from "./ResearchPost";
import QuestionPost from "./QuestionPost";
import PollPost from "./PollPost";
import MilestonePost from "./MilestonePost";
import CollaborationPost from "./CollaborationPost";
import "./RepostPost.css";

const RepostPost = ({ post, onUpdate }) => {
  // Handle case where original post was deleted
  if (!post.originalPost) {
    return (
      <div className="cbx-repost-post">
        {/* Repost Caption */}
        {post.content && (
          <p className="cbx-repost-post__caption">{post.content}</p>
        )}

        {/* Deleted Post Placeholder */}
        <div className="cbx-repost-post__deleted">
          <FiAlertCircle className="cbx-repost-post__deleted-icon" />
          <span>Original post has been deleted</span>
        </div>
      </div>
    );
  }

  const originalPost = post.originalPost;

  // Generate initials for fallback avatar
  const authorName = originalPost.author?.name || "Unknown User";
  const initials = authorName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();

  // Render original post content based on its type
  const renderOriginalContent = () => {
    switch (originalPost.postType) {
      case "text":
        return <TextPost post={originalPost} />;
      case "photo":
        return <PhotoPost post={originalPost} onUpdate={onUpdate} />;
      case "research":
        return <ResearchPost post={originalPost} onUpdate={onUpdate} />;
      case "question":
        return <QuestionPost post={originalPost} onUpdate={onUpdate} />;
      case "poll":
        return <PollPost post={originalPost} onUpdate={onUpdate} />;
      case "milestone":
        return <MilestonePost post={originalPost} />;
      case "collaboration":
        return <CollaborationPost post={originalPost} onUpdate={onUpdate} />;
      default:
        return <TextPost post={originalPost} />;
    }
  };

  return (
    <div className="cbx-repost-post">
      {/* Repost Caption */}
      {post.content && (
        <p className="cbx-repost-post__caption">{post.content}</p>
      )}

      {/* Original Post Card */}
      <motion.div
        className="cbx-repost-post__original"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        whileHover={{ borderColor: "#3b82f6" }}
      >
        <div className="cbx-repost-post__indicator">
          <span className="cbx-repost-post__indicator-icon">
            <FiRepeat />
          </span>
          <span>Reposted from {authorName}</span>
        </div>

        <div className="cbx-repost-post__header">
          {originalPost.author?.profilePhotoUrl ? (
            <img
              src={originalPost.author.profilePhotoUrl}
              alt={authorName}
              className="cbx-repost-post__avatar"
            />
          ) : (
            <div className="cbx-repost-post__avatar cbx-repost-post__avatar--initials">
              {initials}
            </div>
          )}
          <div className="cbx-repost-post__author-info">
            <h4 className="cbx-repost-post__author-name">{authorName}</h4>
            {originalPost.author?.professionalRole && (
              <span className="cbx-repost-post__author-role">
                {originalPost.author.professionalRole}
              </span>
            )}
          </div>
        </div>

        <div className="cbx-repost-post__content">
          {renderOriginalContent()}
        </div>
      </motion.div>
    </div>
  );
};

export default RepostPost;

